import React, { Component } from 'react';
import { CssBaseline, Grid, withStyles } from '@material-ui/core';
import axios from 'axios';
import Topbar from '../common/Topbar';
import Footer from '../common/Footer';
import DownloadList from './DownloadList';
import DownloadDetail from './DownloadDetail';
import Pagination from '../common/Pagination';
import TitleText from '../common/TitleText';
import { API_URL } from '../common/Constants';

const styles = (theme) => ({
  root: {
    overflowX: 'hidden',
    overflowY: 'auto',
    width: '100%',
    // height: 'calc(100vh - 85px)',
    // backgroundColor: '#fafafa',
  },
  pageNumbers: {
    listStyle: 'none',
    display: 'flex',
    padding: 0,
  },
});

class Notice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageState: this.props.location.state && this.props.location.state.pageState ? this.props.location.state.pageState : 'list',
      notiItems: this.props.location.state && this.props.location.state.notiItems ? this.props.location.state.notiItems : null,
      noticeData: [''], //undefined 예외처리
      currentPage: 1,
      noticePerPage: 7,
    };
    this.handleClick = this.handleClick.bind(this);
    this.changePage = this.changePage.bind(this);
  }

  //   관리자 페이지 연동 형식 테스트 innon evt 009로 테스트 함

  componentDidMount() {
    axios
      .get(`${API_URL}/bbs/archive/list`, {
        headers: { Pragma: 'no-cache' },
      })
      .then((response) => {
        if (response.data) {
          let _result = response.data.sort((a, b) => {
            return b.createdAt - a.createdAt;
          });
          this.setState({ noticeData: _result });
        }
      });
  }

  changeState = (newState) => {
    this.setState((prevState) => ({
      pageState: newState,
    }));
  };

  setDetail = (newVal) => {
    this.setState((prevVal) => ({
      notiItems: newVal,
    }));
  };
  handleClick(event) {
    this.setState({
      currentPage: Number(event.target.id),
    });
  }
  changePage(event, type) {
    if (type === 'prev') {
      if (this.state.currentPage > 1) {
        this.setState({
          currentPage: this.state.currentPage - 1,
        });
      }
    } else {
      if (this.state.currentPage < Math.ceil(this.state.noticeData.length / this.state.noticePerPage)) {
        this.setState({
          currentPage: this.state.currentPage + 1,
        });
      }
    }
  }

  render() {
    const { classes } = this.props;
    const currentPath = this.props.location;
    const { noticeData, currentPage, noticePerPage } = this.state;
    const indexOfLastTodo = currentPage * noticePerPage;
    const indexOfFirstTodo = indexOfLastTodo - noticePerPage;
    const currentnoticeData = noticeData.slice(indexOfFirstTodo, indexOfLastTodo);

    return (
      <React.Fragment>
        <CssBaseline />
        <div id="main_container" className={classes.root}>
          <Topbar currentPath={currentPath} />
          <Grid container justify="center" style={{ backgroundColor: '#fafafa' }}>
            <Grid
              id=" content_grid"
              container
              item
              xs={11}
              md={8}
              style={{ backgroundColor: '#ffffff', margin: '4vh 0', borderRadius: '20px' }}
            >
              <TitleText title="자료실" />
              {this.state.pageState === 'list' ? (
                <Grid container style={{ padding: '0 2vw 2vw 2vw' }}>
                  <DownloadList changeState={this.changeState} selectedItem={this.setDetail} data={currentnoticeData} />
                  <Grid container justify="center">
                    <Pagination
                      noticeData={this.state.noticeData}
                      currentPage={this.state.currentPage}
                      noticePerPage={this.state.noticePerPage}
                      handleClick={this.handleClick}
                      changePage={this.changePage}
                    />
                  </Grid>
                </Grid>
              ) : (
                ''
              )}
              {this.state.pageState === 'detail' ? (
                <Grid container style={{ padding: '0 2vw 2vw 2vw' }}>
                  <DownloadDetail changeState={this.changeState} selectedItem={this.state.notiItems} data={this.state.noticeData} />
                </Grid>
              ) : (
                ''
              )}
            </Grid>
          </Grid>
          <Footer />
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(Notice);
